/**
 * @see https://umijs.org/docs/max/access#access
 * */
export default function access(initialState: { currentUser?: API.CurrentUser } | undefined) {
  const { currentUser } = initialState ?? {};
  const isAdmin = currentUser?.username?.toLowerCase() === 'admin';
  return {
    canAdmin: isAdmin,
    // Add privilege-based access controls
    canManageBlock: currentUser?.privileges?.includes('manage-block') || isAdmin,
    canEditGeneralBlock: currentUser?.privileges?.includes('edit-general-block') || isAdmin,
    canEditSectionBlock: currentUser?.privileges?.includes('edit-section-block') || isAdmin,
    canEditPost: currentUser?.privileges?.includes('edit-post') || isAdmin,
    canEditAds: currentUser?.privileges?.includes('edit-ads') || isAdmin,
    canEditSiteSetting: currentUser?.privileges?.includes('edit-site-setting') || isAdmin,
  };
}
